import { useEffect } from "react";
import useAuth from "@/hooks/useAuth";

const Blank = ({ children, isPublic }) => {
  const { isLoggedIn, handleLogout } = useAuth();

  useEffect(() => {
    if (!isPublic && !isLoggedIn) {
      const isAutomaticLoggout = true;
      handleLogout(isAutomaticLoggout);
    }
  }, [isPublic, isLoggedIn, handleLogout]);


  return children
}

export default Blank
